import React from 'react';
import { Input, Row, Col } from 'antd';

const EvaluationSearch = ({ evaluationData, setFilteredData, searchText, setSearchText }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = evaluationData.filter((record) => {
      const matchesCode = record.code?.toLowerCase().includes(value.toLowerCase());
      const matchesArea = record.area?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesAsset = record.assetName?.toLowerCase().includes(value.toLowerCase());
      const matchesDependency = record.dependencyName?.toLowerCase().includes(value.toLowerCase());
      const matchesControl = record.controlTitle?.toLowerCase().includes(value.toLowerCase());
      const matchesStatus = record.status?.toLowerCase().includes(value.toLowerCase());

      return (
        matchesCode ||
        matchesArea ||
        matchesAsset || 
        matchesDependency || 
        matchesControl || 
        matchesStatus
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(evaluationData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Evaluaciones"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default EvaluationSearch;